import { useMemo } from 'react'
import { Col } from 'antd'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { CTALink, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


Box.propTypes = {
  icon: PropTypes.string,
  heading: PropTypes.string.isRequired,
  text: PropTypes.string,
  hover_text: PropTypes.string,
  hover_heading: PropTypes.string,
  cta_link: PropTypes.string,
  cta_link_type: PropTypes.string,
  cta_link_caption: PropTypes.string,
  zIndex: PropTypes.number,
}

export default function Box({
  icon = undefined,
  heading,
  text = undefined,
  hover_text: hoverText = undefined,
  hover_heading: hoverHeading = undefined,
  cta_link: ctaLink = undefined,
  cta_link_caption: caption = undefined,
  zIndex = undefined,
}) {
  const boxStyles = useMemo(() => ({ zIndex }), [zIndex])

  return (
    <Col
      span={24}
      sm={12}
      md={6}
      className={classNames.flipCard}
      style={boxStyles}
    >
      <div className={classNames.inner}>
        <div className={classNames.front}>
          <i className={cx('fa', icon, classNames.icon)} />
          <Typography variant="h3" className={classNames.header}>{heading}</Typography>
          <Typography>{text}</Typography>
        </div>
        <div className={classNames.back}>
          <Typography variant="h3" color="white" className={classNames.flipHeader}>{hoverHeading}</Typography>
          <Typography color="white" className={classNames.flipText}>{hoverText}</Typography>
          <CTALink
            cta={caption}
            ctaURL={ctaLink}
            className={classNames.cta}
          />
        </div>
      </div>
    </Col>
  )
}
